import React from "react"
import PCMEditMain from "./component/PCMEditMain/PCMEditMain"

const PCMEditCare = () => <PCMEditMain />

export default PCMEditCare
